import type { Location } from 'react-router-dom';

export enum RoutineSubmitSource {
  AssetCard = 'asset-card',
  RoutinesList = 'routines-list',
}

export const ALL_ACTIVITIES_QUERY_VALUE = 'activities-all';
export const ALL_ACTIVITIES_QUERY_KEY = `from=${ALL_ACTIVITIES_QUERY_VALUE}`;

export const assetPaths = {
  root: 'assets',
};

const ASSET_ROOT_PATH_PATTERN = /^\/assets\/[^/]+\/?$/;
const ACTIVITY_ASSET_ROOT_PATH_PATTERN =
  /^\/activities\/[^/]+\/asset\/[^/]+\/?$/;

export function isActivityOrEditPage(location: Location<unknown>): boolean {
  return (
    location.pathname.includes('/activity/') ||
    location.pathname.includes('/edit') ||
    location.pathname.includes('/detail') ||
    location.pathname.includes('/routines') ||
    location.pathname.includes('/files')
  );
}

export function isActivitiesParent(location: Location<unknown>): boolean {
  return location.pathname.startsWith('/activities/');
}

// Only base asset panels should hand motion to a newly mounted asset sub-route.
// Sibling sub-routes at the same depth update the right panel in place.
export function shouldUseAssetSubrouteInitialTransition(
  location: Location<unknown>
): boolean {
  return (
    ASSET_ROOT_PATH_PATTERN.test(location.pathname) ||
    ACTIVITY_ASSET_ROOT_PATH_PATTERN.test(location.pathname)
  );
}
